export enum ClientStatusesEnum {
  Active = 'active',
  Inactive = 'inactive'
}

export type StatusTypes = ClientStatusesEnum.Active | ClientStatusesEnum.Inactive;
